import { API_STATUS } from "../../../constants/apiStatus";

// Check for stored auth data on app startup
const getStoredAuthData = () => {
  try {
    const token = localStorage.getItem("authToken");
    const user = localStorage.getItem("authUser");

    if (token && user) {
      return {
        token,
        user: JSON.parse(user),
        // Don't set isAuthenticated=true automatically
        // Let the token verification determine if it's still valid
        isAuthenticated: false,
      };
    }
  } catch (error) {
    console.error("Error reading auth data from localStorage:", error);
    // Clear corrupted data
    localStorage.removeItem("authToken");
    localStorage.removeItem("authUser");
  }

  return {
    token: null,
    user: null,
    isAuthenticated: false,
  };
};

const storedAuth = getStoredAuthData();

export const authSliceInitialState = {
  user: storedAuth.user,
  isAuthenticated: storedAuth.isAuthenticated,
  token: storedAuth.token,
  apiStatus: {
    login: API_STATUS.IDLE,
    logout: API_STATUS.IDLE,
    verify: API_STATUS.IDLE,
    register: API_STATUS.IDLE,
    forgotPassword: API_STATUS.IDLE,
    resetPassword: API_STATUS.IDLE,
  },
  error: null,
};
